import { RightSidePanel } from '@/common/Sidepanel';
import useAlchemystStoreForAi from '@/hooks/ai/client/useAlchemystStoreForAi';
import { Box } from '@mui/material';
import ListTraces from './list-traces';
import ShowTrace from './show-trace';

function TracesPage() {
  const { traceVisualizer, setStoreState } = useAlchemystStoreForAi((store) => ({
    traceVisualizer: store.traceVisualizer,
    setStoreState: store.setStoreState,
  }));

  const handleCloseSidePanel = () => {
    setStoreState({
      traceVisualizer: {
        isOpen: false,
        traceId: null,
      }
    });
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', position: 'relative' }}>
      {/* Black overlay when sidebar is open */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          opacity: traceVisualizer.isOpen ? 1 : 0,
          visibility: traceVisualizer.isOpen ? 'visible' : 'hidden',
          transition: 'opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          zIndex: 1000,
          pointerEvents: traceVisualizer.isOpen ? 'auto' : 'none',
        }}
        onClick={handleCloseSidePanel}
      />

      {/* Main content area */}
      <Box 
        sx={{ 
          flexGrow: 1, 
          width: traceVisualizer.isOpen ? 'calc(100% - 85vw)' : '100%',
          transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          overflow: 'auto',
          padding: 2,
          position: 'relative',
          zIndex: 999,
        }}
      >
        <ListTraces />
      </Box>

      {/* Right side panel for trace visualization */}
      <RightSidePanel
        open={traceVisualizer.isOpen}
        setOpen={(open) => {
          if (typeof open === 'boolean' && !open) {
            handleCloseSidePanel();
          } else if (typeof open === 'function') {
            const newValue = open(traceVisualizer.isOpen);
            if (!newValue) {
              handleCloseSidePanel();
            }
          }
        }}
        panelWidth="85vw"
      >
        {traceVisualizer.traceId && (
          <Box sx={{ height: '100%', width: '100%', overflow: 'auto' }}>
            <ShowTrace traceId={traceVisualizer.traceId} />
          </Box>
        )}
      </RightSidePanel>
    </Box>
  );
}

export default TracesPage;
